import angular from 'angular'
import template from './template.html'

function NominaTimbresConsultarConfirmarComponent() {
  let $ctrl = this

  $ctrl.aceptar = aceptar
  $ctrl.cancelar = cancelar

  function aceptar() {
    $ctrl.onClose({
      $event: {
        data: {
          consultar: true,
        },
      },
    })
  }

  function cancelar() {
    $ctrl.onClose({$event: {}})
  }
}

angular.module('nominas.nomina')
  .component('nominaTimbresConsultarConfirmar', {
    template,
    controller: NominaTimbresConsultarConfirmarComponent,
    bindings: {
      idProyecto: '<',
      idNomina: '<',
      data: '<',
      omitidos: '<',
      onClose: '&',
    },
  })



// WEBPACK FOOTER //
// ./src/nominas/nomina/components/timbres/consultar/confirmar/component.js